module.exports = __webpack_public_path__ + "img/Large-Semi-Elliptical-Attachment-L-34.4638da04.png";